import React from 'react'
import { Button, Paragraph, Separator } from '@fs/zion-ui'
import { useUser } from '@fs/zion-user'
import { useMutation, useQuery } from '@apollo/client/react'
import { css } from '@emotion/core'
import { useImageOrganizeModes, useGroupData } from '../../../../hooks'
import transl from './DivideModeButton.transl'
import mutations from '../../../../mutations'
import { workflowStatuses } from '../../../../helpers'
import queries from '../../../../queries'

const minimizeSpace = css`
  margin-top: 0;
`

export default function DivideModeButton() {
  const { cisId } = useUser()
  const { switchToDivideMode } = useImageOrganizeModes()
  const {
    itemCount,
    group: { id: groupId },
  } = useGroupData()
  const [setDivideWorkflowInProgress] = useMutation(mutations.updateWorkflowActionStatus())
  const { data: imageOrganizeStatusData, loading: imageOrganizeStatusLoading } = useQuery(
    queries.imageOrganizeStatus(),
    {
      variables: { rmsId: groupId },
      skip: !groupId,
    }
  )
  const divideStatus = imageOrganizeStatusData?.imageOrganizeStatus?.divide
  const isDividedGroup = itemCount > 1

  const handleClick = async () => {
    if (!isDividedGroup) {
      await setDivideWorkflowInProgress({
        variables: {
          params: {
            action: workflowStatuses.DIVIDE,
            rmsId: groupId,
            newStatus: workflowStatuses.IN_PROGRESS,
            createNewWorkflowAction: !divideStatus, // if the workflow action doesn't exist we have to create it
          },
        },
      })
    }
    switchToDivideMode()
  }

  return (
    <>
      <Paragraph size="sm" dense>
        {transl.heading()}
      </Paragraph>
      <div css={minimizeSpace}>
        <Paragraph size="xs" secondary>
          {isDividedGroup ? transl.dividedSubheading() : transl.undividedSubheading()}
        </Paragraph>
      </div>
      <Separator size="nano" />
      <Button
        onClick={handleClick}
        disabled={
          imageOrganizeStatusLoading || (divideStatus?.status === 'In Progress' && divideStatus?.userId !== cisId)
        }
        emphasis="medium"
      >
        {isDividedGroup ? transl.updateDividers() : transl.divideImageGroup()}
      </Button>
      <Separator size="nano" />
    </>
  )
}
